module.exports = __webpack_public_path__ + "gd.6e21ec7e5db085d89370.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/gd.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/gd.svg
// module chunks = styles